export default __webpack_public_path__ + "static/media/joint-secretary.f2469ef1.jpg";